import { render, staticRenderFns } from "./GmzHqsjfxTableList.vue?vue&type=template&id=2847926a&scoped=true&"
import script from "./GmzHqsjfxTableList.vue?vue&type=script&lang=js&"
export * from "./GmzHqsjfxTableList.vue?vue&type=script&lang=js&"
import style0 from "./GmzHqsjfxTableList.vue?vue&type=style&index=0&id=2847926a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847926a",
  null
  
)

export default component.exports